export default __webpack_public_path__ + "static/media/bg-img.57af4bef.jpg";